// extracted by mini-css-extract-plugin
export default {"pendingStatus":"PendingView_pendingStatus","title":"PendingView_title","PendingViewSVG":"PendingView_PendingViewSVG","subtitle":"PendingView_subtitle"};